export default function() {
  return new Worker(__webpack_public_path__ + "search.worker-7c9a404fd00ab58de900.worker.js");
}
